import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { colorOptions } from '../../../../constants/constants';
import colorCodeEnum from '../../../../constants/enums/color-code-enum';
import { useStore } from '../../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../../models/forms/IForm';
import DefaultModal from '../../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../../translations/format-message';
import LEDBlinkForm from '../forms/led-blink-form';

interface IProps extends IFormModalProps {
  selectedRows: string[];
  isToolLed: boolean;
  toolId: string;
}

const LEDBlink = (props: IProps) => {
  const { trayManagementStore, dashboardStore, toolManagementStore } =
    useStore();
  const { duplicateData } = trayManagementStore;
  const { ToolLedBlinkService, toolLedBlinkState, resetToolLedBlinkState } =
    toolManagementStore;

  const {
    LEDFormInitialValue,
    TimerOptions,
    ledBlinkState,
    LedBlinkService,
    resetLedBlinkState,
  } = dashboardStore;
  const initialValues: any = LEDFormInitialValue;

  useEffect(() => {
    if (ledBlinkState.success) {
      toast.success(formatMessage('added_success'));
      onModalClosed();
    }
  }, [ledBlinkState.success]);

  useEffect(() => {
    if (toolLedBlinkState.success) {
      // toast.success(formatMessage('added_success'));
      resetToolLedBlinkState();
    }
  }, [toolLedBlinkState.success]);

  useEffect(() => {
    if (toolLedBlinkState.error) {
      resetToolLedBlinkState();
    }
  }, [toolLedBlinkState.error]);

  const onSubmitForm = (data: any) => {
    if (props.isToolLed) {
      ToolLedBlinkService(Number(getTenantIdFromLocalStorage()), props.toolId, {
        ...data,
        ColorCode: colorCodeEnum[data.ColorCode],
      });
    } else {
      LedBlinkService(
        Number(getTenantIdFromLocalStorage()),
        props.selectedRows.join(','),
        {
          ...data,
          ColorCode: colorCodeEnum[data.ColorCode],
        }
      );
    }
    onModalClosed();
  };

  const onModalClosed = () => {
    props.modalClosed();
  };
  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className="correction-modal fancy-modal"
        addHeader="led_title"
        updateHeader="led_title"
        onModalClosed={onModalClosed}
        isLoading={ledBlinkState.inProgress}
      >
        <LEDBlinkForm
          initialValues={initialValues}
          id={props.id}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={ledBlinkState.inProgress}
          duplicateData={duplicateData}
          timerOptions={TimerOptions}
          colorOptions={colorOptions}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(LEDBlink);
